import appsAndPages from "./apps-and-pages";
import dashboard from "./dashboard";
// Array of sections
export default [...dashboard, ...appsAndPages];
